function showSaveUserSuccessSnackbar({ state }) {
  state.merge('client.forms.snackbar', { show: true, success: true })
}

export default showSaveUserSuccessSnackbar



// WEBPACK FOOTER //
// ./src/modules/user/actions/showSaveUserSuccessSnackbar.js